import React, { Fragment } from 'react';
import './notification-component.scss';
import { NOTIFICATION_TYPE, IMAGE_TYPE, CLICK_TYPE } from './notification.constant';

const Notification = ({ show = false, type = NOTIFICATION_TYPE.DEFAULT, message, eventHandler, hideCancelButton = false, onCancel }) => {
  const onMessageClick = (event) => {
    const { innerText, dataset } = event && event.target;
    if (dataset && dataset.type === CLICK_TYPE.LINK) {
      eventHandler && eventHandler({ nodeInfo: dataset, event: event, innerText });
    }
  };

  const renderNotification = (type) => {
    return (
      <div className="notification_section" id={`${message && message.props && message.props.children &&  message.props.children[0]=== false ? 'hide' :'show_toast_data'}`}>
        <div className="network-coverage">
          <div className="container">
            <div data-testid="notification-body" className={`coverageContent ${type}`} onClick={onMessageClick}>
              {message}
            

              {!hideCancelButton && (
                <div role="button" className="crossIcon" onClick={onCancel}>
                  <i className="material-icons">clear</i>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return show ? <Fragment>{ renderNotification(type)}</Fragment> : null;
};

export { Notification, NOTIFICATION_TYPE, CLICK_TYPE };
